var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.156,15.401c-1.758,0-3.184-1.425-3.184-3.184v-6.424c0-1.758,1.425-3.184,3.184-3.184h5.705c1.758,0,3.184,1.425,3.184,3.184"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.955,
    y: 8.599,
    width: 12.072,
    height: 12.792,
    rx: 3.184,
    ry: 3.184
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.2cb626b8372e87771906046d8a68ca89.svg";
export { ForwardRef as ReactComponent };